import { createReducer } from 'typesafe-actions'
import { GetTransactionDetailsResponseDto } from '@sparling/financial-common'
import { ActionTypes } from '../types'
import { LoadingStateEnum } from '../../types'
import { getTransactionDetailsRequest, getTransactionDetailsSuccess, getTransactionDetailsFailure } from '../actions'

export type TransactionsState = {
  transactionDetails: TransactionDetails
}

type TransactionDetails = {
  loading: LoadingStateEnum
  data: GetTransactionDetailsResponseDto | null
  error: Error | null
}

export const initialState = {
  transactionDetails: {
    loading: LoadingStateEnum.IDLE,
    data: null,
    error: null,
  },
}

export const transactions = createReducer<TransactionsState, ActionTypes>(initialState)
  .handleAction(getTransactionDetailsRequest, (state) => ({
    ...state,
    transactionDetails: {
      ...state.transactionDetails,
      loading: LoadingStateEnum.LOADING,
    },
  }))
  .handleAction(getTransactionDetailsSuccess, (state, { payload }) => ({
    ...state,
    transactionDetails: {
      ...state.transactionDetails,
      loading: LoadingStateEnum.SUCCESS,
      data: payload,
    },
  }))
  .handleAction(getTransactionDetailsFailure, (state, { payload }) => ({
    ...state,
    transactionDetails: {
      ...state.transactionDetails,
      loading: LoadingStateEnum.ERROR,
      error: payload,
    },
  }))
